import React from "react";
import { Props } from "./types";

function AlignLeftIcon({ className }: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="16"
      height="16"
    >
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="11" x2="14" y2="11" />
      <line x1="3" y1="16" x2="21" y2="16" />
      <line x1="3" y1="21" x2="14" y2="21" />
    </svg>
  );
}

export { AlignLeftIcon };
